import * as React from "react"
import parse from 'html-react-parser';
import { Link } from "gatsby"
import VideoBoxAutoplay from "../components/VideoBoxAutoplay"

import { stripTags } from '../Helpers'

const Hero = ({ img, h1, title, text, position, btn, overlay, type, video, button }) => {



   if(type !== undefined && type === 'video' && video) {
      return (
         <section className="relative w-full hero video-hero">

            <div className="relative w-full h-full">
               {overlay ?
                  <div className="absolute w-full h-full left-0 top-0 z-10" style={{background: overlay}}></div>
               : ''}
               {button ?
                  <div className="absolute w-full h-full left-0 top-0 z-30">
                     <div className="container mx-auto h-full flex items-start md:items-center justify-end">
                        {button.url ?
                           <a href={button.url}>
                              <img className="max-h-40 md:max-h-64 lg:max-h-80 mt-8 md:mt-0" srcSet={button.srcSet} sizes="(max-width: 400px) 100vw, 400px" />
                           </a>
                        :
                           <img className="max-h-40 md:max-h-64 lg:max-h-80 mt-8 md:mt-0" srcSet={button.srcSet} sizes="(max-width: 400px) 100vw, 400px" />
                        }
                     </div>
                  </div>
               : ''}
               <VideoBoxAutoplay videoSrc={video} backupImg={img} />
               <div className="absolute w-full left-0 bottom-12 z-20">
                  <div className={position === 'right' ? 'container mx-auto flex flex-col items-end' : 'container mx-auto'}>
                     {h1 === 'true' ? <h1>{parse(title)}</h1> : <span className="text-4xl lg:text-5xl font-bold uppercase m-0">{parse(title)}</span>}
                     {text === 'false' ? '' : <div className="hero-description">{parse(text)}</div>}
                     {btn ? <Link className={btn.color + ' rounded-full py-3 px-4 ' + btn.bgColor} to={btn.link}>{btn.text}</Link> : ''}
                  </div>
               </div>
            </div>
         </section>
      )
   } else {
      return (
         <section className="h-auto w-full py-12 hero bg-gradient-to-b from-gray-50 to-gray-300">
             <div className="container mx-auto px-4 h-full grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-end">
                <div className="order-1 md:order-2">
                   <img className="max-h-120 mx-auto md:mr-0 mb-0" srcSet={img} alt={parse(stripTags(title))} sizes="(max-width: 2560px) 100vw, 2560px" />
                </div>
                 <div className="order-2 md:order-1">
                     {h1 === 'true' ? <h1 className="m-0">{parse(title)}</h1> : <span className="text-4xl lg:text-5xl font-bold uppercase m-0">{parse(title)}</span>}
                     {text === 'false' ? '' : <div className="hero-description">{parse(text)}</div>}
                     {btn ? <Link className={btn.color + ' rounded-full py-3 px-4 ' + btn.bgColor} to={btn.link}>{btn.text}</Link> : ''}
                 </div>
             </div>
         </section>
      )
   }
}

export default Hero
